import React from 'react';
import { TemplateRequestForm } from '@/vacancy_request/components/template-request-form';
import { defaultFormValues } from '@/vacancy_request/components/template-request-form/options-group/constants';
import {
  BackgroundOverlay,
  ContentContainer,
  TitleForm
} from '@/vacancy_request/components/template-request-form/styled';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { HrIconButton, HrSecondary } from '@components/styles/hr-styles';

const CreateTemplateRequestView = () => {
  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form');

  return (
    <>
      {/* Fondo con dos colores */}
      <BackgroundOverlay />

      {/* Contenido principal */}
      <ContentContainer>
        <TitleForm>
          <HrIconButton
            fontSize='24px'
            color={HrSecondary}
            className='hr-Carret-left'
            onClick={() => {
              window.location.href = '/app/configuration/vacancy_request';
            }}
            style={{ marginRight: '8px', cursor: 'pointer' }}
          />
          {t('titles.create')}
        </TitleForm>

        <TemplateRequestForm mode='create' formValues={defaultFormValues} couldBeDraft />
      </ContentContainer>
    </>
  );
};

CreateTemplateRequestView.propTypes = {};

export default CreateTemplateRequestView;
